import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
/* import CryptoJS from "crypto-js"; */
const ServiceCard = ({ services }) => {
  const navigate = useNavigate();
  const handleLaunch = () => {
    /* const customerServiceData = {
      customerServiceId: services.id,
      customerBusinessId: services.customerBusinessId,
    };
    const encryptedCustomerServiceData = CryptoJS.AES.encrypt(
      JSON.stringify(customerServiceData),
      process.env.REACT_APP_SECRET_KEY
    ).toString();
    const encryptedQueryParam = encodeURIComponent(
      encryptedCustomerServiceData
    );
    navigate(`/legaltools/singlememberllcform/${encryptedQueryParam}`); */
    navigate(`/legaltools/singlememberllcform/${services.id}`);
  };

  useEffect(() => {
    document.title = "Single Member LLC Form";
  }, []);

  return (
      <div className="col-lg-4 col-md-6 col-sm-12">
        <div className="card w-100 card-span">
          <div class="py-2 px-3 card-border d-flex align-items-center justify-content-between">
               <h4 className="text-start card-heading mb-0">{services.serviceName}</h4>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-submit-secondary py-1 px-2" onClick={handleLaunch}>
                    {services.statusName === "Submitted" ? "View" : "Complete Form"}
                  </button>
                </div>
          </div>
          {/* <figure className="text-center">
                <img src="/libra.png" className="img-fluid logo-dark" alt="congrats"></img>
            </figure> */}
          {/* <h4 className="text-center mb-4 heading">{services.serviceName}</h4> */}
          {/* <span className="text-center mb-4 heading">{services.description}</span> */}
          <div class="card-body px-3 py-4">
              <div className="row">
                  <div className="col-lg-12 margin-left">
                      <div className="row">
                      <div className="col-lg-6 mb-1">
                        <h6 className="">Business Name:</h6>
                      </div>
                      <div className="col-lg-6 mb-1">
                        <span className="d-block">{services.businessName}</span>
                      </div>
                      <div className="col-lg-6 mb-1">
                        <h6 className="">Date:</h6>
                      </div>
                      <div className="col-lg-6 mb-1">
                        <span className="d-block">
                          {new Date(services.createdDate).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          })}
                        </span>
                      </div>
                      <div className="col-lg-6 mb-1">
                        <h6 className="">Status:</h6>
                      </div>
                      <div className="col-lg-6 mb-1">
                        <span className={services.statusName==="In progress"?"in-progress":"complete"}>{services.statusName}</span>
                      </div>
                      </div>
                  </div>
              </div>

              
          </div>
        </div>
      </div>
  );
};
export default ServiceCard;
